import axios from 'axios'
import Config from "Config";

export const request = axios.create({ baseURL: Config.api });